import { Link } from "react-router-dom";

const cols = [
  {
    title: "Agenzia",
    links: [
      { label: "Servizi", href: "/#servizi", type: "anchor" },
      { label: "Chi siamo", href: "/#chi-siamo", type: "anchor" },
      { label: "Pacchetti", href: "/#pacchetti", type: "anchor" },
      { label: "Clienti", href: "/#clienti", type: "anchor" },
    ],
  },
  {
    title: "Legale",
    links: [
      { label: "Privacy Policy", href: "/privacy", type: "route" },
      { label: "Cookie Policy", href: "/cookie", type: "route" },
      { label: "Area riservata", href: "/admin/login", type: "route" },
    ],
  },
  {
    title: "Contatti",
    links: [
      { label: "info@socialwhale.it", href: "mailto:info@socialwhale.it", type: "ext" },
      { label: "+39 351 326 9205", href: "tel:+393513269205", type: "ext" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 pt-20 pb-10 mt-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3">
              <img src="/assets/logo.png" alt="Logo Social Whale — brand di La Palma Ent" className="h-11 w-11 object-contain drop-shadow-[0_0_18px_rgba(147,51,234,0.5)]" />
              <span className="font-display font-bold text-2xl text-white">
                Social<span className="text-gradient">Whale</span>
              </span>
            </Link>
            <p className="mt-6 text-slate-400 max-w-md leading-relaxed">
              L&apos;agenzia che unisce digitale e negozio fisico per far emergere il tuo brand
              nel mare dei social.
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="text-xs uppercase tracking-[0.25em] text-purple-300/80 mb-4">{c.title}</div>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    {l.type === "route" ? (
                      <Link to={l.href} className="text-sm text-slate-300 hover:text-white transition break-words">{l.label}</Link>
                    ) : (
                      <a
                        href={l.href}
                        target={l.type === "ext" && l.href.startsWith("http") ? "_blank" : undefined}
                        rel={l.type === "ext" && l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                        className="text-sm text-slate-300 hover:text-white transition break-words"
                      >{l.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1" />
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-slate-500 leading-relaxed">
            <div className="text-slate-300 font-medium">Social Whale</div>
            <div>A brand by <span className="text-slate-300">La Palma Ent</span> · P. IVA IT04151810928</div>
            <div>Sede: Via Lungo Saline 101, 09126 Cagliari (CA), Italia</div>
            <div className="mt-1">© {new Date().getFullYear()} La Palma Ent. Tutti i diritti riservati.</div>
          </div>
          <div className="text-xs text-slate-500">
            Made with <span className="text-gradient font-semibold">passione</span> in Sardegna.
          </div>
        </div>
      </div>
    </footer>
  );
}
